import React, { useState, useEffect, useContext } from 'react';

// Import components
import Button from '../../components/button/button';
import { noHeaderContext, navigationContext, iOS } from '../../context';

// //////////////////////////////////
// Component
const FullScreen = () => {

    // Properties
    const [isFullScreen, setIsFullScreen] = useState(false);
    const noHeader = useContext(noHeaderContext);
    const tooltipText = isFullScreen ? 'Quitter le mode plein écran' : 'Passer en plein écran';

    useEffect(() => {
        const checkFullScreen = () => {
            const domElement = document.getElementById("root");

            const wx = domElement.clientWidth;
            const wy = domElement.clientHeight;

            if (window.screen.width === wx && window.screen.height === wy) {
                setIsFullScreen(true);
            } else {
                setIsFullScreen(false);
            }
        }
        window.addEventListener("resize", checkFullScreen)

        return () => {
            window.removeEventListener("resize", checkFullScreen)
        }
    }, [])

    // Fonctions
    const toogleFullScreen = () => { // Gestion du toogle de fullScreen
        const domElement = document.getElementById("root");

        if (!isFullScreen) {
            if (domElement.requestFullscreen) {
                domElement.requestFullscreen();
            } else if (domElement.mozRequestFullScreen) {
                domElement.mozRequestFullScreen();
            } else if (domElement.webkitRequestFullscreen) {
                domElement.webkitRequestFullscreen();
            } else if (domElement.msRequestFullscreen) {
                domElement.msRequestFullscreen();
            }
            setIsFullScreen(true);
            toggleMobileTestVisibility(false);

        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            setIsFullScreen(false);
            toggleMobileTestVisibility(true);
        }
    }

    const toggleMobileTestVisibility = (show) => {
        const mobileTestDiv = document.getElementById('mobile-test');
        if (mobileTestDiv) {
            if (show) {
                mobileTestDiv.style.display = 'flex';
            } else {
                mobileTestDiv.style.display = 'none';
            }
        }
    }

    // Render
    return (
        <navigationContext.Consumer>
            {datas => (datas != null) &&
                <div id='fullScreen' className={noHeader ? 'noHeader' : ''}>
                    <Button
                        customClass='btn-fullScreen'
                        icon={'picto-fullscreen'}
                        state={isFullScreen}
                        onClick={() => toogleFullScreen()}
                        displayText={datas.displayText}
                    />
                    <span class="toolTipTextOptions">{tooltipText}</span>
                </div>
            }
        </navigationContext.Consumer>
    );
}

export default FullScreen;